import { i18n } from "../i18n/i18n";
import { openSite } from "../net/OpenSite";

/** End loading on failure; keep recovery usable even when WebGL never started. */
export function showBootError(error: unknown): void {
  document.getElementById("boot")?.remove();
  document.getElementById("boot-error")?.remove();
  const message = error instanceof Error ? error.message : String(error);
  const root = document.createElement("section");
  root.id = "boot-error";
  root.className = "boot-error overlay";
  root.setAttribute("role", "alertdialog");
  root.setAttribute("aria-labelledby", "boot-error-title");
  root.setAttribute("aria-describedby", "boot-error-hint");
  root.setAttribute("aria-modal", "true");
  root.innerHTML = `<div class="panel boot-error-panel">
    <p class="boot-error-brand">VOID HUNTER</p>
    <h1 id="boot-error-title"></h1><p id="boot-error-hint"></p>
    <div class="menu-btns"><button class="btn primary" data-a="retry"></button>
    <button class="btn" data-a="site"></button></div>
    <details><summary></summary><pre></pre></details>
  </div>`;
  root.querySelector("h1")!.textContent = i18n.t("boot.errorTitle");
  root.querySelector("#boot-error-hint")!.textContent = i18n.t(/webgl|graphics|context/i.test(message) ? "boot.webglHint" : "boot.errorHint");
  const retry = root.querySelector<HTMLButtonElement>('[data-a="retry"]')!;
  retry.textContent = i18n.t("boot.retry");
  retry.onclick = () => window.location.reload();
  const site = root.querySelector<HTMLButtonElement>('[data-a="site"]')!;
  site.textContent = i18n.t("menu.site");
  site.onclick = () => void openSite();
  root.querySelector("summary")!.textContent = i18n.t("boot.details");
  root.querySelector("pre")!.textContent = message;
  // Clear partially constructed menus so no broken controls remain in the tab order.
  const ui = document.getElementById("ui-root");
  if (ui) ui.replaceChildren(root);
  else document.body.appendChild(root);
  retry.focus();
}
